import React, { useState } from 'react';
import Grid from 'src/ui/library/Grid/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import iconTransform from 'src/helpers/iconTransform';
// import PercentageCircle from 'src/ui/library/PercentageCircle';
import styled from 'src/ui/library/styled';
import QuestionnaireSectionItemsPres from './QuestionnaireSectionItemsPres';
import flattenSubMenu from 'src/helpers/flattenSubMenu.js';

// const goldColor = '#f5a623';
// const greenColor = '#2eb757';

const styles = (theme, props) => ({
  root: {},
  panelRoot: {
    marginBottom: '16px',
    boxShadow: 'none',
    border: '1px solid #C4C4CE',
    padding: '0px !important',
    borderRadius: '0 !important',
    '&:before': {
      backgroundColor: 'transparent',
    },
  },
  panelSummaryRoot: {
    backgroundColor: '#efeff2',
    boxShadow: '0 0 8px 0 rgba(0,0,0,0.08)',
    '&+ div': {
      display: 'none',
    },
    '&$panelSummaryExpanded': {
      backgroundColor: theme.colors.eyGrey4,
      borderBottom: `solid 1px ${theme.colors.eyGrey6}`,
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.08)',
    },
    '&$panelSummaryExpanded + div': {
      display: 'block',
    },
    '&$panelSummaryFocused': {
      backgroundColor: '#1A1A24',
      color: '#FFFFFF',
    },
  },
  panelSummaryContent: {
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '12px 0 !important',
    '& > :last-child': {
      paddingRight: '0px',
    },
  },
  panelSummaryIcon: {
    fontSize: '33px',
  },
  panelSummaryExpanded: {
    minHeight: 'auto !important',
  },
  panelSummaryFocused: {
    backgroundColor: '#1A1A24',
    color: '#FFFFFF',
  },
  panelDetails: {
    padding: '8px',
    '& .section-item': {
      padding: '15px',
    },
    '& > :first-of-type': {
      margin: 0,
      border: 'none',
      paddingBottom: 0,
      width: '100%',
      '& > :first-of-type': {
        margin: '10px 0',
      },
    },
  },
  panelTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  panelIcon: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  heading: {},
});

const getDescriptionText = (descriptionsArr, value) => {
  if (!descriptionsArr) {
    return '';
  }
  let descriptionText = descriptionsArr.filter(d => d.sectionName === value);
  descriptionText = descriptionText[0] ? descriptionText[0].description : '';
  return descriptionText;
};

export const QuestionnaireAccordionSectionPres = ({
  orderIndex,
  introData,
  push,
  match,
  readMore,
  toggleReadMore,
  isMobile,
  welcomeMessage,
  history,
  itemDetail,
  sectionProgress,
  classes,
}) => {
  const data = introData;
  match.params.sectionName = itemDetail.menuName;
  const [expanded, setExpanded] = useState(true);
  let flattenedSubMenu = [];
  if (itemDetail.subMenu && itemDetail.subMenu.length) {
    flattenedSubMenu = flattenSubMenu(itemDetail.subMenu);

    // let sessionMenu = subMenu.map(menu => {
    //   return {pageName:menu.menuName, pageId:menu.pageId}
    //});
    // sessionStorage.setItem('qType',introData.questionnaireName);
    //setMenuItemsInSessionStorage(JSON.stringify(sessionMenu));
  }
  return (
    <React.Fragment>
      <Accordion className="questionnaire-item" classes={{ root: classes.panelRoot }} defaultExpanded>
        <AccordionSummary
          classes={{
            root: classes.panelSummaryRoot,
            content: classes.panelSummaryContent,
            expanded: classes.panelSummaryExpanded,
            focusVisible: classes.panelSummaryFocused,
          }}
          onClick={() => setExpanded(!expanded)}>
          <Grid container spacing={0}>
            <Grid item xs={1}>
              <div
                className={classes.panelSummaryIcon}
                dangerouslySetInnerHTML={{ __html: expanded ? '&#8722;' : '+' }}
              />
            </Grid>
            <Grid item xs={2} className="icon-wrapper">
              {iconTransform(itemDetail.icon, !isMobile && { fontSize: 40 })}
            </Grid>
            <Grid item xs={9}>
              <p>{itemDetail.menuName}</p>
              {!isMobile && <p>{getDescriptionText(data.descriptions, itemDetail.menuName)}</p>}
            </Grid>
            {/* <Grid item xs={2} className="text-center">
							<PercentageCircle
							  color={
								sectionProgress === 100 ? greenColor : goldColor
							  }
							  percent={sectionProgress}
							  radius={25}
							  textStyle="circle-font-size"
							  borderWidth={4}
							/>
						  </Grid> */}
          </Grid>
        </AccordionSummary>
        <AccordionDetails classes={{ root: classes.panelDetails }}>
          <div className="questionnaire-section-container">
            <QuestionnaireSectionItemsPres items={flattenedSubMenu} params={match.params} clickHandler={push} />
          </div>
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  );
};

export default styled(QuestionnaireAccordionSectionPres)(styles);
